import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthState, AUTH_PHASE } from "@/contexts/AuthContext";
import {
    ADMIN_LOGIN,
    APP_DASHBOARD,
    isAdminSession,
    isAuthPending,
    isAuthenticatedUser,
    isSuperadmin,
} from "@/lib/authRouting";

const ADMIN_SECURITY_PATH = "/admin/security";

/** Redirect-only guard — never replaces layout; AppLayout stays mounted. */
export function AppRouteGuard() {
    const { user, authPhase, sessionType } = useAuthState();
    const location = useLocation();

    if (isAuthPending(authPhase) || !isAuthenticatedUser(user)) {
        if (authPhase === AUTH_PHASE.ANONYMOUS) {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
        return <div className="route-guard-pending w-full min-h-[min(28rem,calc(100vh-8rem))]" aria-hidden data-testid="app-route-guard-pending" />;
    }

    if (isSuperadmin(user)) {
        if (isAdminSession(sessionType)) {
            return <Navigate to="/admin/dashboard" replace />;
        }
        return <Navigate to={ADMIN_LOGIN} replace />;
    }

    return <Outlet />;
}

export function AdminRouteGuard() {
    const { user, authPhase, sessionType } = useAuthState();
    const location = useLocation();

    if (isAuthPending(authPhase) || !isAuthenticatedUser(user)) {
        if (authPhase === AUTH_PHASE.ANONYMOUS) {
            return <Navigate to={ADMIN_LOGIN} state={{ from: location.pathname }} replace />;
        }
        return <div className="route-guard-pending w-full min-h-[min(28rem,calc(100vh-8rem))]" aria-hidden data-testid="app-route-guard-pending" />;
    }

    if (!isSuperadmin(user)) {
        return <Navigate to={APP_DASHBOARD} replace />;
    }

    if (!isAdminSession(sessionType)) {
        return <Navigate to={ADMIN_LOGIN} replace />;
    }

    if (!user.totp_enabled && location.pathname !== ADMIN_SECURITY_PATH) {
        return <Navigate to={ADMIN_SECURITY_PATH} replace />;
    }

    return <Outlet />;
}
